import PropTypes from "prop-types";
import React from "react";
import styles from "../../styles/createTest/AddAudience.css";

import AddAudienceHeader from "./AddAudienceHeader";

const WAIT_INTERVAL = 200;
export default class AddCustomAudience extends React.PureComponent {
    static propTypes = {
        audienceDescription: PropTypes.string,
        onAudienceDescriptionChange: PropTypes.func.isRequired,
        isReadOnly: PropTypes.bool.isRequired
    };

    static placeHolderText = "Add request here...";

    constructor(props) {
        super(props);
        this.state = {
            audienceDescription: this.props.audienceDescription
        };
    }

    componentWillMount() {
        this.timer = null;
    }

    handleTextChange(description) {
        clearTimeout(this.timer);

        this.setState({ audienceDescription: description });

        this.timer = setTimeout(
            description =>
                this.props.onAudienceDescriptionChange(
                    this.state.audienceDescription
                ),
            WAIT_INTERVAL
        );
    }

    render() {
        return (
            <div className={styles.addCustomAudience}>
                <AddAudienceHeader
                    iconNames={["cog"]}
                    title="Custom Audience"
                    isReadOnly={this.props.isReadOnly}
                />
                <div className={styles.customAudienceText}>
                    {!this.state.audienceDescription && (
                        <div className={styles.optionalLabel}> Optional</div>
                    )}
                    <textarea
                        className={styles.textArea}
                        placeholder={AddCustomAudience.placeHolderText}
                        value={this.state.audienceDescription || ""}
                        onChange={event =>
                            this.handleTextChange(event.target.value)
                        }
                        disabled={this.props.isReadOnly}
                    />
                    <div className={styles.helpText}>
                        <p className={styles.header}>
                            Need another type of request?
                        </p>
                        <p>
                            Leave a note for our Customer Success team if you
                            need a demographic not shown or have a special
                            request for your audience needs.
                        </p>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CreateTest/AddCustomAudience.js